
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselComponent } from '../../../../modules/carousel/carousel.component';
import { CarouselTile } from '../../../../modules/carousel/carousel.model';


@Component({
  selector: 'app-jugend-carousel',
  imports: [
    CarouselComponent
  ],
  templateUrl: './jugend-carousel.component.html',
  styleUrls: ['./jugend-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JugendCarouselComponent {

  public tiles: CarouselTile[] = [
    {
      img: {
        src: 'assets/img/jugend5.jpg',
        // width: 1120,
        // height: 744,
        alt: 'Cool Kids',
        //style: 'width:100%;height:100%;object-fit:cover;object-position:50% 35%;',
        objectPosition: '50% 35%',
        // srcset: [
        //   'assets/img/xs/jugend5.webp 688w',
        //   'assets/img/sm/jugend5.webp 912w',
        //   'assets/img/md/jugend5.webp 1120w',
        //   'assets/img/lg/jugend5.webp 1360w',
        //   'assets/img/xl/jugend5.webp 2320w',
        // ],
        sizes: ['90vw'],
        priority: true,
        loading: 'eager',
      }
    },
    {
      img: {
        src: 'assets/img/jugend4.jpg',
        // width: 1120,
        // height: 1493,
        alt: 'Welcome Kids',
        //style: 'width:100%;height:100%;object-fit:cover;object-position:50% 43%;',
        objectPosition: '50% 43%',
        // srcset: [
        //   'assets/img/xs/jugend4.webp 688w',
        //   'assets/img/sm/jugend4.webp 912w',
        //   'assets/img/md/jugend4.webp 1120w',
        //   'assets/img/lg/jugend4.webp 1360w',
        //   'assets/img/xl/jugend4.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/jugend2.jpg',
        // width: 1120,
        // height: 891,
        alt: 'Happy to sail',
        // style: 'width:100%;height:100%;object-fit:cover;object-position:50% 25%;',
        objectPosition: '50% 25%',
        // srcset: [
        //   'assets/img/xs/jugend2.webp 688w',
        //   'assets/img/sm/jugend2.webp 912w',
        //   'assets/img/md/jugend2.webp 1120w',
        //   'assets/img/lg/jugend2.webp 1360w',
        //   'assets/img/xl/jugend2.webp 1601w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/jugend3.jpg',
        // width: 1120,
        // height: 840,
        alt: 'Kids together',
        // srcset: [
        //   'assets/img/xs/jugend3.webp 688w',
        //   'assets/img/sm/jugend3.webp 912w',
        //   'assets/img/md/jugend3.webp 1120w',
        //   'assets/img/lg/jugend3.webp 1360w',
        //   'assets/img/xl/jugend3.webp 2320w',
        // ],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    // {
    //   img: {
    //     src: 'assets/img/jugend6.jpg',
    //     // width: 1120,
    //     // height: 744,
    //     alt: 'Kids on the water',
    //     //style: 'width:100%;height:100%;object-fit:cover;object-position:50% 35%;',
    //     objectPosition: '50% 35%',
    //     // srcset: [
    //     //   'assets/img/xs/jugend6.webp 688w',
    //     //   'assets/img/sm/jugend6.webp 912w',
    //     //   'assets/img/md/jugend6.webp 1120w',
    //     //   'assets/img/lg/jugend6.webp 1360w',
    //     //   'assets/img/xl/jugend6.webp 2320w',
    //     // ],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    {
      img: {
        src: 'assets/img/kick-off-24-ilca-start-01.jpg',
        // width: 5400,
        // height: 3803,
        alt: 'Start ILCA beim Kick-Off 24',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/jugend7.jpg',
        // width: 5400,
        // height: 3803,
        alt: 'Jugend-Regatta im YSTM',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/jugend8.jpg',
        // width: 5400,
        // height: 3583,
        alt: 'Abend-Ausflug mit dem Hein-Stude im YSTM',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
  ];
}
